import * as api from './middleware/api.middleware';
import { IAccess, IMailBox, ITrusteeResponse, IUserRole } from '../interfaces/mailbox.interfaces';
import { IResponseCollection } from '../interfaces/general.interfaces';
import { IMiddlewareOptions } from './middleware/interfaces';

const serviceUrl = '/mailboxservice/v2';

export const createAccess = (access: IAccess, mailboxId: string): Promise<IAccess> => {
    const data = {
        accessType: access.accessType,
        identityId: access.identityId,
        introductionCompleted: access.introductionCompleted,
        privileges: access.privileges,
    };
    return api.post<IAccess>(`${serviceUrl}/mailboxes/${mailboxId}/accesses`, data);
};

export const getMailboxRoles = (errorCodesHandled: number[]): Promise<IResponseCollection<IUserRole>> => {
    const middlewareOptions: IMiddlewareOptions = {
        errorCodeOptions: { errorCodesHandled },
    };
    return api.get<IResponseCollection<IUserRole>>(`${serviceUrl}/user-roles`, null, middlewareOptions);
};

export const getMailbox = (mailboxId: string, errorCodesHandled: number[]): Promise<IMailBox> => {
    const middlewareOptions: IMiddlewareOptions = {
        errorCodeOptions: { errorCodesHandled },
    };
    return api.get<IMailBox>(`${serviceUrl}/mailboxes/${mailboxId}`, null, middlewareOptions);
};

export const getTrustees = (): Promise<ITrusteeResponse> => {
    return api.get<ITrusteeResponse>(`${serviceUrl}/mailboxes/trustees?SortField=name&SortOrder=asc`);
};

export const updateAccessNotificationSettings = (access: IAccess, mailboxId: string): Promise<IAccess> => {
    const data = {
        version: access.version,
        smsNotificationSubscription: access.smsNotificationSubscription,
        emailNotificationSubscriptions: access.emailNotificationSubscriptions,
        pushNotificationSubscriptions: access.pushNotificationSubscriptions,
    };
    return api.put<IAccess>(`${serviceUrl}/mailboxes/${mailboxId}/accesses/${access.id}`, data);
};

export const updateIntroductoionCompleted = (access: IAccess, mailboxId: string): Promise<IAccess> => {
    const data = {
        id: access.id,
        version: access.version,
        transactionId: access.transactionId,
        createdDateTime: access.createdDateTime,
        lastUpdated: access.lastUpdated,
        accessType: access.accessType,
        mailboxId: mailboxId,
        identityId: access.identityId,
        introductionCompleted: true,
        privileges: access.privileges,
    };
    return api.put<IAccess>(`${serviceUrl}/mailboxes/${mailboxId}/accesses/${access.id}`, data);
};
